import Config from '@config';
import {
  FiltersGrid,
  Pagination,
  infiniteQueryOptions,
  normalizeInfiniteQueryData,
} from '@gasbi/shared/index';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

import {
  AcceptanceTransferActListItemReadModel,
  AcceptanceTransferActReadModel,
} from './types';

export const acceptanceTransferActsApi = createApi({
  reducerPath: 'acceptanceTransferActsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: Config.VITE_API_URL + '/acceptance-transfer-acts',
  }),
  tagTypes: ['AcceptanceTransferActs', 'AcceptanceTransferAct'],
  endpoints: builder => ({
    getAcceptanceTransferActsI: builder.infiniteQuery<
      AcceptanceTransferActListItemReadModel[],
      FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: '/',
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: ['AcceptanceTransferActs'],
    }),
    getAcceptanceTransferActById: builder.query<
      AcceptanceTransferActReadModel,
      string
    >({
      query: id => ({ url: `/${id}` }),
      providesTags: (_, __, id) => [{ type: 'AcceptanceTransferAct', id }],
    }),
  }),
});

export const { useGetAcceptanceTransferActByIdQuery } =
  acceptanceTransferActsApi;

export const useGetAcceptanceTransferActsIInfiniteQuery =
  normalizeInfiniteQueryData(
    acceptanceTransferActsApi.useGetAcceptanceTransferActsIInfiniteQuery,
  );
